import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
	const {
		answerCount,
		rightFeedbackProps,
		leftFeedbackProps,
	} = state.rootReducer.testPageDetails;

	return {
		answerCount,
		rightFeedbackProps,
		leftFeedbackProps,
	};
};

const TextFeedback = ({
	answerCount,
	rightFeedbackProps: {
		textCorrectAnswer,
		correctAnswer,
		selectedAnswer,
		userAnswer,
		passage,
		defaultFeedback,
		score,
	},
	leftFeedbackProps: { question, qtype },
}) => {
	var UserAndCorrectAnswer = '';
	textCorrectAnswer = !!textCorrectAnswer ? textCorrectAnswer : correctAnswer;
	if (typeof score !== 'undefined') {
		if (score > 0) {
			// correct answer
			UserAndCorrectAnswer = (
				<span>
					<h4 className="text-success">That's Correct</h4>

					<div className="quiz-area-answer">
						<div className="display-flex align-center">
							<div className="bord-right col-md-3">
								<h4 className="text-success text-right">Your answer</h4>
							</div>
							<p className="pad-all mar-no">
								<span dangerouslySetInnerHTML={{ __html: userAnswer }} />
							</p>
						</div>
					</div>
				</span>
			);
		} else if (score === 0) {
			// wrong answer
			UserAndCorrectAnswer = (
				<span>
					<h4 className="text-danger">That's incorrect</h4>

					<div className="quiz-area-answer">
						<div className="display-flex align-center">
							<div className="bord-right col-md-3">
								<h4 className="text-danger text-right">Your answer</h4>
							</div>
							<p className="pad-all mar-no">
								<span dangerouslySetInnerHTML={{ __html: userAnswer }} />
							</p>
						</div>
						{!!correctAnswer && qtype !== 'LA' && (
							<div className="display-flex align-center">
								<div className="bord-right col-md-3">
									<h4 className="text-success text-right">Correct answer</h4>
								</div>
								<p className="pad-all mar-no">
									<span>{correctAnswer}</span>
								</p>
							</div>
						)}
					</div>
				</span>
			);
		} else if (score === -1) {
			// ungraded question
			UserAndCorrectAnswer = (
				<span>
					<h4 className="text-ungraded">That's Correct</h4>

					<div className="quiz-area-answer">
						{!!userAnswer && (
							<div className="display-flex align-center">
								<div className="bord-right col-md-3">
									<h4 className="text-ungraded text-right">Your answer</h4>
								</div>
								<p className="pad-all mar-no">
									<span dangerouslySetInnerHTML={{ __html: userAnswer }} />
								</p>
							</div>
						)}
					</div>
				</span>
			);
		} else {
		}
	}

	return <div>{UserAndCorrectAnswer}</div>;
};

export default connect(mapStateToProps)(TextFeedback);
